import React from 'react';
import PropertyAgencyAssigner from '../../components/PropertyAgencyAssigner';

const PropertyAgencyAssignerPage: React.FC = () => {
  return <PropertyAgencyAssigner />;
};

export default PropertyAgencyAssignerPage;